const EDI_API_ENDPOINTS = {
  getGs1LabelTypes: `/api/edi/gs1-label-types/`,
  updateRetailer: (id: number) => `/api/edi/retailer/${id}/`,
  createRetailer: `/api/edi/retailer/`,
}

export { EDI_API_ENDPOINTS }
